// login-frontend/src/components/Katie/phaser/scenes/ResultScene.js
import Phaser from "phaser";

export default class ResultScene extends Phaser.Scene {
    constructor() { super("Result"); }

    create() {
        const ctx = this.registry.get("ctx") || {};
        const answers = this.registry.get("answers") || [];
        const lastAns = answers.find(a => a.id === 62);
        const playerName = ctx.playerName || "User";

        const choseKatie = lastAns && /A/i.test(lastAns.answer);
        const { width: W, height: H } = this.scale;

        this.cameras.main.setBackgroundColor(choseKatie ? "#fffaf5" : "#f0f9ff");

        const endingText = choseKatie
            ? (ctx.lang === "zh"
                ? "你选择了成为凯蒂。"
                : "You chose to become Katie.")
            : (ctx.lang === "zh"
                ? `你依然是你，${playerName}。`
                : `You’re still yourself, ${playerName}.`);

        // headline
        this.add.text(W / 2, H / 2 - 60, endingText, {
            fontFamily: "system-ui",
            fontSize: "22px",
            color: "#0f172a",
            align: "center",
            wordWrap: { width: W * 0.8 }
        }).setOrigin(0.5);

        const sub = choseKatie
            ? (ctx.lang === "zh"
                ? "“身份同步完成...”"
                : "“Identity transfer complete”")
            : (ctx.lang === "zh"
                ? "“你仍然拥有自我意识…暂时。”"
                : "“You still have self-awareness… for now.”");

        this.add.text(W / 2, H / 2 - 20, sub, {
            fontFamily: "system-ui",
            fontSize: "16px",
            color: "#475569",
            align: "center"
        }).setOrigin(0.5);

        // Return button (styled like BootScene Cancel)
        const btn = document.createElement("button");
        btn.textContent = ctx.lang === "zh" ? "返回 Dashboard" : "Return to Dashboard";
        Object.assign(btn.style, {
            position: "absolute",
            left: "50%", top: "50%",
            transform: "translate(-50%, 120px)",
            padding: "10px 16px",
            border: "1px solid #e2e8f0",
            borderRadius: "10px",
            background: "#f1f5f9",
            color: "#0f172a",
            fontSize: "15px",
            cursor: "pointer",
            zIndex: 10
        });
        btn.addEventListener("click", () => {
            try {
                const bgm = this.registry.get("bgm");
                if (bgm && bgm.isPlaying) bgm.stop();
            } catch { }
            const ctx2 = this.registry.get("ctx");
            if (ctx2 && typeof ctx2.onExit === "function") {
                ctx2.onExit(); // goes back to Dashboard (same as BootScene cancel)
            } else {
                window.location.assign("/Dashboard");
            }
            this.game.destroy(true);
        });

        this.game.canvas.parentNode.appendChild(btn);
        this._btnEl = btn;

        this.events.once(Phaser.Scenes.Events.SHUTDOWN, () => {
            try { btn.remove(); } catch { }
        });
    }
}

